import api from './client'

// Casos de entrega: reposición y DEVOLUCIÓN por producto defectuoso
// (retiro → recepción → DEVOLUCIÓN en Presea → reintegros). Martin, 2 oct 2026.
export const casosApi = {
  listar: (params) => api.get('/casos-entrega', { params }),
  obtener: (id) => api.get(`/casos-entrega/${id}`),
  abrirDevolucion: (remitoId, data) => api.post(`/remitos/${remitoId}/abrir-devolucion`, data),
  repartir: (id, reparto) => api.put(`/casos-entrega/${id}/reparto`, { reparto }),
  retiroAndreani: (id) => api.post(`/casos-entrega/${id}/retiro-andreani`),
  etiquetaRetiro: (id) => api.get(`/casos-entrega/${id}/retiro-andreani/etiqueta`, { responseType: 'blob' }),
  retiroPropio: (id, data) => api.post(`/casos-entrega/${id}/retiro-propio`, data),
  recibir: (id, notas) => api.post(`/casos-entrega/${id}/recibir`, { notas: notas || null }),
  devolucionPresea: (id, numeros) => api.post(`/casos-entrega/${id}/devolucion-presea`, { numeros }),
  reintegrar: (id, reintegroId, data) => api.post(`/casos-entrega/${id}/reintegros/${reintegroId}`, data),
  // Cierre manual de una reposición (la que entrega una salida o Andreani se cierra sola).
  resolver: (id) => api.post(`/casos-entrega/${id}/resolver`),
  ajusteInterno: (id, referencia) => api.post(`/casos-entrega/${id}/ajuste-interno`, { referencia: referencia || null }),
}
